import React, { useRef, useState } from "react";
import { useEffect } from "react";
import { observer, useLocalStore } from "mobx-react";
import IsdTextBox from "./isdTextBox";
const IsdDoubleTextbox = observer(React.forwardRef((props, ref) => {
    ref = {
        textInputfirst: useRef(null),
        textInputlast: useRef(null)
    }

    const state = useLocalStore(() => ({
        first: '',
        last: ''
    }))

    useEffect(() => {
        state.first = props.value && props.value.first ? props.value.first : '';
        state.last = props.value && props.value.last ? props.value.last : '';
    }, [props.value]);

    return (<>
        <IsdTextBox className={`input-grid ${props.classNamefirst || props.className}`} dataGrid
            isdmaxlength={props.isdmaxlengthfirst || props.isdmaxlength}
            maxintlength={props.maxintlengthfirst || props.maxintlength}
            maxdeclength={props.maxdeclengthfirst || props.maxdeclength}
            ctrlproptype={props.ctrlproptypefirst || props.ctrlproptype}
            padchar={props.padcharfirst || props.padchar}
            disabled={props.disabledfirst || props.disabled}
            width={props.widthfirst || props.width}
            value={state.first}
            ref={ref.textInputfirst} />
        <IsdTextBox className={`input-grid ${props.classNamelast || props.className}`} dataGrid
            isdmaxlength={props.isdmaxlengthlast || props.isdmaxlength}
            maxintlength={props.maxintlengthlast || props.maxintlength}
            maxdeclength={props.maxdeclengthlast || props.maxdeclength}
            ctrlproptype={props.ctrlproptypelast || props.ctrlproptype}
            padchar={props.padcharlast || props.padchar}
            disabled={props.disabledlast || props.disabled}
            value={state.last}
            ref={ref.textInputlast} />
    </>);
}))
export default IsdDoubleTextbox;